import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: auto;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 8px;
  padding: 15px;
  gap: 20px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  gap: 15px;
`;

export const PaymentOption = styled.button`
  padding: 15px;
  border: 1px solid ${(props) => props.theme.colors.opaqueText};
  border-radius: 6px;
  background: none;
  cursor: pointer;
`;

export const Input = styled.input`
  position: relative;
  border: none;
  border-bottom: 2px solid black;
  width: auto;
  padding-bottom: 1px;
  font-size: 18px;
  margin-top: 10px;
  color: black;
  outline: none;
`;

export const PixInput = styled.input`
  position: relative;
  border: none;
  border-bottom: 2px solid black;
  width: auto;
  padding-bottom: 1px;
  font-size: 18px;
  margin-top: 10px;
  margin-bottom: 15px;
  color: black;
  outline: none;
`;
